import styled from 'styled-components'
import { t, jt } from 'ttag'
import { useHistory } from 'react-router-dom'

import { Panel } from '@h2/common/components/panel'
import { features } from '@h2/components/media'
import { SG, PB30T } from '@h2/components/colors'
import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { PromoButton } from '@h2/components/buttons/promo'
import { Text } from '@h2/components/typography/text'
import { Heading } from '@h2/components/typography/heading'
import { Icon } from '@h2/components/display/icon'
import activitiesSvg from '@h2/assets/svg/illustrations/source/activities.svg'
import researchSvg from '@h2/assets/svg/illustrations/source/research.svg'

import { WorkingWithOthers } from './workingWithOthers'

const activities = <span key="activities">{t`completing activities`}</span>
const research = <span key="research">{t`doing research`}</span>
const ActivitiesResearchFlex = styled(Flex)`
  span[role='img'] {
    margin-right: 20px;
  }

  @media (${features.minWidth.desktop}) {
    flex-direction: row;
    padding: 0;

    span[role='img'] {
      margin-right: 15px;

      svg {
        width: 190px;
      }
    }

    span[aria-label^='science'] {
      svg {
        width: 180px;
      }
    }

    p {
      font-size: 18px;
      line-height: 22px;
    }

    @media (${features.maxWidth.widescreen}) {
      > div {
        flex-direction: column;
        align-items: normal;

        &:first-child {
          margin-right: 20px;
        }

        span[role='img'] {
          align-items: normal;
          margin: 0 0 15px 0;
        }
      }
    }
  }
`
const WorkingBox = styled(Box)`
  display: none;

  @media (${features.minWidth.desktop}) {
    display: block;
    margin-left: 20px;

    @media (${features.maxWidth.widescreen}) {
      margin-top: 60px;
    }
  }
`
const FlexWrap = styled(Flex)`
  @media (${features.minWidth.desktop}) {
    flex-direction: row;
    padding: 50px 0;

    h2 {
      font-size: 34px;
      text-align: left;
      margin: 0 0 20px 0;
    }

    @media (${features.maxWidth.widescreen}) {
      h2 {
        width: 146%;
      }
    }
  }
`
const ActivitiesAndResearch = () => {
  const history = useHistory()

  return (
    <Panel>
      <FlexWrap direction="column" py="20px" alignItems="center">
        <Flex direction="column">
          <Box>
            <Heading
              level="2"
              weight="light"
              align="center"
              mark="span"
              ml="25px"
              mr="25px"
              markColor={SG}
              variant="mixed-weight">
              {jt`Find out more by ${activities} and ${research}`}
            </Heading>
          </Box>
          <ActivitiesResearchFlex direction="column" px="20px">
            <Flex py="20px" alignItems="center">
              <Icon
                label="activity icons"
                width="150px"
                height="auto"
                dangerouslySetGlyph={activitiesSvg}
              />
              <Box>
                <Text color={PB30T} size="medium">
                  {t`Use activities such as the Interest, Work Importance, and Skills Profilers to learn more about yourself.`}
                </Text>
                <PromoButton
                  display="blue"
                  variant="flatter"
                  onClick={() => history.push('/assessments')}>
                  {t`Complete activities`}
                </PromoButton>
              </Box>
            </Flex>
            <Flex py="20px" alignItems="center">
              <Icon
                label="science icons"
                width="150px"
                height="auto"
                dangerouslySetGlyph={researchSvg}
              />
              <Box>
                <Text color={PB30T} size="medium">
                  {t`Find out more about your options and inform your choices about pathways, colleges, and occupations.`}
                </Text>
                <PromoButton
                  display="red"
                  variant="flatter"
                  onClick={() => history.push('/explore')}>
                  {t`Do some research`}
                </PromoButton>
              </Box>
            </Flex>
          </ActivitiesResearchFlex>
        </Flex>
        <WorkingBox>
          <WorkingWithOthers type="research" shade="green" size="small" />
        </WorkingBox>
      </FlexWrap>
    </Panel>
  )
}

export { ActivitiesAndResearch }
